import { listMarketingViewsApi } from 'api/marketingApi';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const DEFAULT_MARKETING_VIEW_VALUE = '';

export const marketingViewSelectOptions = (views) => {
  if (!views?.length) {
    return [];
  }
  return [
    { label: 'Default', value: DEFAULT_MARKETING_VIEW_VALUE },
    ...views.map((view) => ({ label: view.name, value: view.id })),
  ];
};

export const useMarketingViews = (customerId) => {
  const [views, setViews] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadViews = useCallback(async () => {
    if (!customerId) {
      setViews([]);
      return [];
    }
    setLoading(true);
    try {
      const data = await listMarketingViewsApi({ customerId });
      const nextViews = Array.isArray(data) ? data : [];
      setViews(nextViews);
      return nextViews;
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  useEffect(() => {
    loadViews().catch(() => {
      setViews([]);
    });
  }, [loadViews]);

  const options = useMemo(() => marketingViewSelectOptions(views), [views]);

  return { views, options, loading, reload: loadViews };
};
